import { render } from "./Directing.vue?vue&type=template&id=75d99226&ts=true"
import script from "./Directing.vue?vue&type=script&lang=ts"
export * from "./Directing.vue?vue&type=script&lang=ts"

import "./Directing.vue?vue&type=style&index=0&id=75d99226&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DanhGia_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__